function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BLOCK_TYPES } from './constants';
export default class BlocksDocument {
  constructor(blocks = [], stepsSinceLastChange = []) {
    _defineProperty(this, "blocks", void 0);
    _defineProperty(this, "stepsSinceLastChange", void 0);
    this.blocks = blocks;
    this.stepsSinceLastChange = stepsSinceLastChange;
  }
  get onlyAttachmentListBlock() {
    return this.blocks.find(b => b.type === BLOCK_TYPES.ATTACHMENT_LIST);
  }
  get excludingAttachmentListBlock() {
    return new BlocksDocument(this.blocks.filter(b => b.type !== BLOCK_TYPES.ATTACHMENT_LIST), this.stepsSinceLastChange);
  }
  equals(other) {
    return other === this || JSON.stringify(other.blocks) === JSON.stringify(this.blocks);
  }
  append(block) {
    if (block) {
      return new BlocksDocument(this.blocks.slice(0).concat(block), this.stepsSinceLastChange);
    }
    return new BlocksDocument(this.blocks.slice(0), this.stepsSinceLastChange);
  }
  appendMultiple(blocks) {
    let blocksWithContent = blocks.filter(block => {
      let blockType = typeof block;
      return block !== null && blockType !== 'undefined';
    });
    if (blocksWithContent.length > 0) {
      return new BlocksDocument(this.blocks.slice(0).concat(blocksWithContent), this.stepsSinceLastChange);
    }
    return new BlocksDocument(this.blocks.slice(0), this.stepsSinceLastChange);
  }
}